export function watchIsMobile(app) {
  const update = () => {
    app.config.globalProperties.$isMobile =
      Math.max(document.documentElement.clientWidth, window.innerWidth) < 1024
  }
  update()
  window.addEventListener('resize', update)
}
